// Dung lượng file — dùng chung cho dòng file và cho phần tổng ở đầu danh sách,
// để hai con số không bao giờ làm tròn khác nhau.
export const formatFileSize = (bytes) => {
  if (!bytes) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / 1048576).toFixed(2)} MB`;
};

export default formatFileSize;
